/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import RunningFocusTimer from './RunningFocusTimer';
import { pushSetTaskList, setFocusTasksList, setTaskList, updateSetTaskList } from "../../redux/slices/TaskSlice";
import { completedTask, createTask, updateTaskList } from "../action/common";
import { useDispatch } from "react-redux";
import FocusTimerBar from "./FocusTimerBar";
import moment from "moment";
import { arrayMoveImmutable } from 'array-move';
import { sortableContainer, sortableElement, sortableHandle } from "react-sortable-hoc";
import DragIcon from "../../pages/Tasks/DragIcon";
import EditTaskList from "../../pages/AddTasks/EditTaskList";
import { rrulestr } from "rrule";
import momentTimezone from "moment-timezone";
import RecurringIcon from "../../pages/Tasks/RecurringIcon";
import { Checkbox } from "../LandingHeader/Feedback/icons/Icons";
import AddTaskStatic from "../../pages/AddTasks/AddTaskStatic";
import TaskSourceIcon from "../../pages/Tasks/TaskSourceIcon";
import ProjectTagIcon from "../../pages/Tasks/ProjectTagIcon";
import { convertUrlsToLinks } from "../action/utilities";
import TaskModal from "../../pages/Settings/Modal/TaskModal";

const DragHandle = sortableHandle(() => <span className="dragdrop-option"><DragIcon /></span>);

const SortableItem = sortableElement(({children, task, editTaskHandler}) => (
  <li className="task-item li-task-list hr-line overflow-x-hidden" onClick={e => editTaskHandler(e, task)}
    css={{
      '&:hover': {
        background: `none !important`,
      }
    }}
    >
    <DragHandle />
    {children}
  </li>
));

const SortableContainer = sortableContainer(({children}) => {
    
    return (
      <ul className="ul-task-list incomplete-tasks">{children}</ul>
    )
});

function FocusModeStart({timerPaused = false}) {
  const [editTask, setEditTask] = useState(null);
  const [updatedValue, setUpdatedValue] = useState(null);
  const theme = useSelector(state => state.theme.theme);
  const {focusTasksList, taskList} = useSelector(state => state.task);
  const focusTimer = useSelector(state => state.focusTimer);
  const {pause} = focusTimer;
  const dispatch = useDispatch();
  let taskIndex = 0

  // useEffect(() => {
  //   // Trigger timer in wepapp and other clients
  //   if (socket !== null){
  //     const user = decodeToken(localStorage.getItem('token'));
  //     socket.emit('focusTimer', {room: user['outseta:accountUid'], data: {timer: focusTimer, tasks: focusTasksList}});
  //   }
  // }, [])

  useEffect(() => {
    if(pause === true){
     // navigate("/focus-mode-completed");
    }
  }, [pause]);

  useEffect(() => {
    if(updatedValue !== null){
      dispatch(setFocusTasksList([...focusTasksList].map(task => task.id == updatedValue.id ? {...task, title: updatedValue.title} : task)));
    }
  }, [updatedValue])

  const onCompleteTask = async (task, status = 1) => {
    let requestBody = {
      "id": task?.id,
      status
    }
    try {
      let tasks = [...focusTasksList];
      const newTaskDate = moment().startOf('date').toISOString();

      if(task?.repeat?.rule){
        const rruleSet = rrulestr(task?.repeat?.rule, {
          forceset: true,
        })
        // If this is a recurring task and want to complete the current occurrence
        rruleSet.exdate(momentTimezone(newTaskDate).tz(momentTimezone.tz.guess()).endOf('day').toDate())
        const updatedTask = {id: task.id, repeat: {...task?.repeat, rule: rruleSet.toString()}}
        await updateTaskList(updatedTask)
        dispatch(updateSetTaskList(updatedTask));

        // Extract relevant fields from task object
        const {
          title,
          tags,
          Project,
          time,
          repeat,
          week,
          timeZone,
          taskSource
        } = task;
  
        const response = await createTask({
          title,
          tags,
          project: Project?.title ?? null,
          time,
          week,
          timeZone, 
          status, 
          completedAt: newTaskDate, 
          date: newTaskDate, 
          repeat: repeat ? {...repeat, rule: null} : null,
          origTaskId: task?.id,
          orgRepeatId: task?.orgRepeatId,
          taskSource
        })
        dispatch(pushSetTaskList(response?.data?.responseData?.data));
        tasks = [...focusTasksList].map(t => t.id == task.id ? response?.data?.responseData?.data : t);
      }else{
        await completedTask({...requestBody, orgRepeatId: task?.orgRepeatId, completedAt: newTaskDate});
        tasks = [...focusTasksList].map(t => t.id == task.id ? { ...t, status, completedAt: status == 1 ? newTaskDate : null } : t);
        const todayTasks = [...taskList].map(t => t.id == task.id ? { ...t, status, completedAt: status == 1 ? newTaskDate : null } : t);
        dispatch(setTaskList(todayTasks));
      }
      dispatch(setFocusTasksList(tasks));
    } catch ({ response }) {

    }
    // try {
    //   await completedTask(requestBody);
    //   const tasks = [...focusTasksList].map(t => t.id == task.id ? { ...t, status, completedAt: status == 1 ? new Date() : task.completedAt } : t);
    //   dispatch(setFocusTasksList(tasks));
    // } catch ({ response }) {}
  };

  const onSortEnd = ({oldIndex, newIndex}) => {
    const newList = arrayMoveImmutable(focusTasksList, oldIndex, newIndex);
    dispatch(setFocusTasksList(newList))
  };

  const editTaskHandler = (e, task) => {
    if(!e.target?.closest('.check-container'))
      setEditTask(task);
  }

  const fitTextInContainer = () => {
      const container = document.querySelector('.task-title.darkPrimaryColor');
      if(!container)
        return;
      const containerWidth = container.clientWidth;
      const containerHeight = 200; //container.clientHeight;
      let fontSize = parseInt(window.getComputedStyle(container).fontSize, 10);
      
      // Gradually reduce the font size until the text fits
      while (container.scrollWidth > containerWidth || container.scrollHeight > containerHeight) {
          fontSize--;
          container.style.fontSize = `${fontSize}px`;
      }
  }

  useEffect(() => {
    fitTextInContainer()
  }, [focusTasksList]);

  return (
    <div className={`main-body-wrap focus-timer-bg break-focus-page break-timer-start focus-mode-timer-start`} css={{
      '.task-formatting':{
        'a, .task-description':{
          opacity: `1 !important`,
          lineHeight: `normal`
        },
        '.task-description':{
          fontSize: `45%`
        }
      }
    }}>
      {/* <div className={`backgroundBottom ${theme}`} style={{bottom: 0}}>
        <BackgroundImage height="975" />
      </div> */}
      <div className={`page-wrapper focus-mode-start`} id="focus-mode-settings-page">
        <div className="page-container">
          <div className="quoteSection breakTime">
            <RunningFocusTimer defaultMaximizTimer={false} focusMode={true} display={false} />
          </div>
          <div className={`tasks-list-container ${theme}`}>
            {/* <div className="focused-items-heading">
              Focus Session {focusSessions.filter(session => moment().format('L') === moment(session.startTime).format('L')).length} {focusTasksList.length > 0 ? <span style={{color: colorPicker}}>{focusTasksList.filter(t => t.status == 1).length} Completed</span> : null}<span style={{color: theme === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.5)'}}> / {focusTasksList.length}</span>
            </div> */}
            <AddTaskStatic />
            <div className="focus-mode-new-task">
              <div className="focus-session-tasks" style={{background: 'transparent'}}>
                <SortableContainer lockAxis="y" helperClass="sortable-helper" onSortEnd={onSortEnd} helperContainer={document.querySelector('.page-container')} useDragHandle>
                  {focusTasksList.map((task, index) => {
                    return task.status == 0 ?
                    (
                        <SortableItem key={`item-${task.id}`} index={index} editTaskHandler={editTaskHandler} task={task}>
                          <>
                            <Checkbox name={task?.id} task={task} currentDate={new Date()} defaultValue={task?.id} onClick={e => onCompleteTask(task)} colorPicker={`var(--accent-color)`}/>
                            <span
                                className={`task-title text-black dark:text-white`} data-tip data-for={`longText-${task?.id}`}>
                                  <div className="task-formatting">
                                    <span className={`${taskIndex++ === 0 ? 'darkPrimaryColor block' : ''}`} dangerouslySetInnerHTML={{__html: convertUrlsToLinks(task?.title)}} />
                                    {task?.description && <div className="task-description" dangerouslySetInnerHTML={{__html: convertUrlsToLinks(task?.description) ?? ''}} />}
                                  </div>
                                <div className="flex items-center justify-start gap-[10px]">
                                  <TaskSourceIcon task={task} colorPicker={`var(--accent-color)`} />
                                  <RecurringIcon task={task} colorPicker={`var(--accent-color)`} />
                                  <ProjectTagIcon task={task} opacity='100' />
                                </div>
                            </span>
                          </>
                        </SortableItem>
                    )
                    :
                    null
                  })
                }
                </SortableContainer>
                <ul className="ul-task-list">
                {
                    focusTasksList.map(task => {
                        return task.status == 1 ? <li className="task-item li-task-list completed-task hr-line" key={task.id}
                        css={{
                          '&:hover': {
                            background: `none !important`,
                          }
                        }}
                        >
                          <Checkbox defaultChecked={true} task={task} currentDate={new Date()}  name={task?.id} defaultValue={task?.id} onClick={e => onCompleteTask(task, 0)} colorPicker={`var(--accent-color)`}/>
                          <span
                              className='task-title text-black dark:text-white' data-tip data-for={`longText-${task?.id}`}>
                                  <div className="task-formatting">
                                    <span dangerouslySetInnerHTML={{__html: convertUrlsToLinks(`<s>${task?.title}</s>`)}} />
                                    {task?.description && <div className="task-description" dangerouslySetInnerHTML={{__html: convertUrlsToLinks(task?.description) ?? ''}} />}
                                  </div>
                              <div className="flex items-center justify-start gap-[10px]">
                                <TaskSourceIcon task={task} colorPicker={`var(--accent-color)`} />
                                <RecurringIcon task={task} colorPicker={`var(--accent-color)`} />
                                <ProjectTagIcon task={task} opacity='100' />
                              </div>
                          </span>
                      </li> : null
                    })
                }
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        {
          !timerPaused
          ?
          <FocusTimerBar showSec={true} />
          :
          <FocusTimerBar resumeTimerFlag={true} showSec={true} />
        }
      </div>
      {
        editTask !== null
        &&
        <TaskModal
            show={true}
            editTaskData = {
                {
                    hideActions: true,
                    item: editTask,
                    setUpdatedValue: setUpdatedValue,
                    setEditTaskId: setEditTask
                }
            }
        />
      }
    </div>
  )
}

export default FocusModeStart
